var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMediumStar = function SvgMediumStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC308",
    d: "m14.103 7.434-1.82 1.754c-.25.24-.42.721-.367 1.065l.282 2.056c.184 1.315-.631 1.885-1.81 1.272L8.39 12.535c-.334-.175-.881-.165-1.206.028l-1.75 1.023c-1.38.806-2.206.198-1.838-1.358l.514-2.173c.094-.396-.08-.938-.377-1.207L2.077 7.354c-1.183-1.07-.853-2.041.74-2.164l2.018-.15c.377-.029.834-.326 1.009-.66l1.046-2c.618-1.173 1.613-1.168 2.211.015l.934 1.848c.16.31.565.613.91.664l2.498.406c1.348.217 1.645 1.174.66 2.121"
  })));
};
export default SvgMediumStar;